import React from 'react';
import PropTypes from 'prop-types';

import css from './IconBannedUser.module.css';

const IconBannedUser = props => {
  const { className } = props;
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 0C4.30117 0 2.1 2.28693 2.1 5.09091C2.1 6.84375 2.96133 8.40057 4.26562 9.31818C1.76914 10.4318 0 13.0057 0 16H1.4C1.4 12.7784 3.89922 10.1818 7 10.1818C10.1008 10.1818 12.6 12.7784 12.6 16H14C14 13.0057 12.2309 10.4318 9.73438 9.31818C11.0387 8.40057 11.9 6.84375 11.9 5.09091C11.9 2.28693 9.69883 0 7 0ZM7 1.45455C8.94141 1.45455 10.5 3.07386 10.5 5.09091C10.5 7.10795 8.94141 8.72727 7 8.72727C5.05859 8.72727 3.5 7.10795 3.5 5.09091C3.5 3.07386 5.05859 1.45455 7 1.45455Z" fill="white" />
    </svg>
  );
};

IconBannedUser.defaultProps = { className: null };

const { string } = PropTypes;

IconBannedUser.propTypes = { className: string };

export default IconBannedUser;
